var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vwc-button",
    {
      class: _vm.extraClass,
      attrs: {
        id: _vm.id,
        label: _vm.label,
        disabled: _vm.disabled,
        type: _vm.type,
        layout: _vm.layout,
        shape: _vm.shape,
        dense: _vm.dense,
        "full-width": _vm.fullWidth,
        "trailing-icon": _vm.trailingIcon,
        icon: _vm.icon,
        connotation: _vm.connotation,
      },
      on: { click: (ev) => _vm.onClick(ev) },
    },
    [[_vm._t("trailingIcon")]],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }